import { useState, useEffect } from "react";
import "./BOSForm.css";
import Cookies from "js-cookie";
import axios from "../axios.jsx";
import Spinner from "../Images/spinner-removebg-preview.png";
import Done from "../Images/right.png";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export default function BOSForm(props) {
    const [disable, setDisable] = useState(props.viewMode);
    const [viewMode, setViewMode] = useState(props.viewMode);
    const [scholarID, setScholarID] = useState("");
    const [nameOfScholar, setNameOfScholar] = useState("");
    const [subject, setSubject] = useState("");
    const [title, setTitle] = useState("");
    const [nameOfSupervisor, setNameOfSupervisor] = useState("");
    const [date, setDate] = useState("");
    const [nameOfBOS, setNameOfBOS] = useState("");
    const [signatureOfBOS, setSignatureOfBOS] = useState("");
    function removeNavbar() {
        document.getElementsByClassName("navbar")[0].style.display = "none";
    }
    const printyo = () => {
        removeNavbar();
        window.print();
    };
    useEffect(() => {
        setSubject(props.subjectFromPrev);
        if (viewMode) {
            console.log(props.panelData);
            console.log(props.adjuticatorsData);
            setAdjuticators(props.adjuticatorsData);
            setData(props.panelData);
        }
    }, []);
    function setData(scholar_data) {
        setScholarID(scholar_data.scholar_id);
        setDate(scholar_data.date);
        setNameOfScholar(scholar_data.name_of_scholar);
        setNameOfSupervisor(scholar_data.name_of_supervisor);
        setNameOfBOS(scholar_data.name_of_BOS);
        setSignatureOfBOS(scholar_data.signature_of_BOS);
        setSubject(scholar_data.subject);
        setTitle(scholar_data.title);
    }

    const initial_data = [
        {
            id: 1,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }, {
            id: 2,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }
        , {
            id: 3,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }, {
            id: 4,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }, {
            id: 5,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }, {
            id: 6,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }, {
            id: 7,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }, {
            id: 8,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        }, {
            id: 9,
            name: "",
            department: "",
            name_of_university: "",
            state: "",
            mobile: "",
            email: "",
        },
    ];
    const [adjuticators, setAdjuticators] = useState(initial_data);
    function changeDisable(event) {
        event.preventDefault();
        setDisable(!disable);
    }
    function changeValue(index, attribute, value) {
        let newData = [...adjuticators];
        newData[index - 1][attribute] = value;
        setAdjuticators(newData);
    }
    async function handleFileUpload(file) {
        setSignatureOfBOS("load");
        let form_data = new FormData();
        form_data.append("file", file);
        form_data.append("file_name", "bos_signature");
        if (scholarID === "") {
            alert("first give that scholarId")
        }
        form_data.append("mobile", scholarID);
        try {
            const resData = await axios.post("/api/file-upload", form_data);
            if (resData.status === 200) {
                setSignatureOfBOS(resData.data["file-name"]);
            }
        } catch (e) {
            console.log(e);
        }
    }

    async function createBOSPanel(event) {
        event.preventDefault();
        try {
            var reqData = {
                scholarID,
                nameOfScholar,
                subject,
                title,
                nameOfSupervisor,
                date,
                nameOfBOS,
                signatureOfBOS,
                adjuticators,
            };
            const resData = await axios.post("/api/set-bospanel", reqData);
            if (resData.status === 201) {
                console.log(resData.data);
                alert("BOS panel added succesfully");
            }
        }
        catch (e) {
            alert("something went wrong try again");
        }
    }
    function handleBack() {
        Cookies.remove("id");
        window.location.href = "/bospanels-list";
    }
    return (<>
        <br /><br />
        <div className="whole">
            <center>
                <form onSubmit={e => (changeDisable(e))} className="form-a">
                    <br />
                    <p style={{ "fontSize": "28px", "textDecoration": "underline" }}>Panel of Adjuticators</p><br />
                    <div className="date-field">
                        Date : <input value={date} onChange={e => { setDate(e.target.value) }} className="adj-input" type="date" disabled={disable} required />
                    </div ><br />
                    <div className="form-header">
                        To<br />
                        The COE,<br />
                        Kakatiya University,<br />
                        Warangal.<br /><br />
                        <table className="scholar-details-table">
                            <tr>
                                <td >
                                    Scholar ID
                                </td >
                                <td > <input className="adj-input" value={scholarID} onChange={e => { setScholarID(e.target.value) }} type="text" disabled={disable} required />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Name of the Scholar
                                </td >
                                <td > <input className="adj-input" value={nameOfScholar} onChange={e => { setNameOfScholar(e.target.value) }} type="text" disabled={disable} required />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Subject
                                </td >
                                <td > <input className="adj-input" value={subject} onChange={e => { setSubject(e.target.value) }} type="text" disabled="true" required />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Title
                                </td >
                                <td > <input className="adj-input" value={title} onChange={e => { setTitle(e.target.value) }} type="text" disabled={disable} required />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Name of the Supervisor
                                </td >
                                <td > <input className="adj-input" value={nameOfSupervisor} onChange={e => { setNameOfSupervisor(e.target.value) }} type="text" disabled={disable} required />
                                </td>
                            </tr>
                        </table>
                        <br />
                    </div>
                    <center>
                        <table className="adjuticators-table">
                            <tr>
                                <th width="3%">Sno.</th>
                                <th width="17%">Name of the Adjuticator</th>
                                <th width="13%">Department</th>
                                <th width="17%">Name of University and Address</th>
                                <th width="14%">State</th>
                                <th width="13%">Mobile No.</th>
                                <th width="13%">E-mail</th>
                            </tr>
                            {adjuticators.map((adjuticator, i) =>
                                <tr key={i}>
                                    <th>{adjuticator.id}.</th>
                                    <td><input className="adj-input" disabled={disable} value={adjuticator.name} onChange={e => changeValue(adjuticator.id, "name", e.target.value)} required></input></td>
                                    <td><input className="adj-input" disabled={disable} value={adjuticator.department} onChange={e => changeValue(adjuticator.id, "department", e.target.value)} required></input></td>
                                    <td><input className="adj-input" disabled={disable} value={adjuticator.name_of_university} onChange={e => changeValue(adjuticator.id, "name_of_university", e.target.value)} required></input></td>
                                    <td><input className="adj-input" disabled={disable} value={adjuticator.state} onChange={e => changeValue(adjuticator.id, "state", e.target.value)} required></input></td>
                                    <td><input className="adj-input" type="number" max="9999999999" disabled={disable} value={adjuticator.mobile} onChange={e => changeValue(adjuticator.id, "mobile", e.target.value)} required></input></td>
                                    <td><input type="email" className="email-input adj-input" disabled={disable} value={adjuticator.email} onChange={e => changeValue(adjuticator.id, "email", e.target.value)} required></input></td>
                                </tr>
                            )}
                        </table>
                    </center>
                    <br />
                    <div className="note-view">
                        <b>Note:</b>
                        <ul>
                            <li>Adjudicator must not below Associate Professor Rank.</li>
                            <li>More than one Adjudicator is not allowed from same University/Institute.</li>
                            <li>The above Panel of Adjuticators have been Approved by Board Of Studies.</li>
                            <li>Fill the Adjudicators as following 1-3 from Telangana State and 4-9 from Other States.</li>
                        </ul>
                    </div>
                    <br />
                    <div className="bos-signature">

                        <table >
                            <tr>
                                <td width="40%">
                                    Signature
                                </td>
                                <td>
                                    : {
                                        !viewMode ? (
                                            <>
                                                <input
                                                    onChange={(e) =>
                                                        handleFileUpload(e.target.files[0])
                                                    }
                                                    className="adj-input"
                                                    required={signatureOfBOS === "" ? true : false}
                                                    type="file"
                                                    disabled={disable}
                                                />
                                                {signatureOfBOS === "load" ? (
                                                    <div style={{ "padding-top": "5px" }}>
                                                        <img className="spinner_img" src={Spinner} alt="" />
                                                        &nbsp;&nbsp;Uploading
                                                    </div>
                                                ) : (
                                                    signatureOfBOS !== "" && (
                                                        <div style={{ "padding-top": "5px" }}>
                                                            <span className="file-name">
                                                                <img className="done_img" src={Done} alt="" />
                                                                &nbsp;{signatureOfBOS}
                                                            </span>
                                                        </div>
                                                    )
                                                )}
                                            </>
                                        ) :
                                            (
                                                <span className="file-name">
                                                    <img width="250px" height="90px" className="signature_img" src={axios.defaults.baseURL + "api" + signatureOfBOS} alt="" />
                                                </span>
                                            )
                                    }


                                </td>
                            </tr>
                            <tr>
                                <td> Name of the Chairperson BOS
                                </td>
                                <td>
                                    : <input className="adj-input" value={nameOfBOS} onChange={e => { setNameOfBOS(e.target.value) }} type="text" disabled={disable} required />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <br />
                    {(disable && !viewMode) && (<>
                        <button
                            className="btn btn-secondary"
                            onClick={(e) => changeDisable(e)} style={{ "width": "20%", "margin-right": "5%" }} >
                            Edit
                        </button>
                        <button
                            onClick={(e) => createBOSPanel(e)}
                            className="btn btn-secondary" style={{ "width": "20%", "margin-left": "5%" }}>
                            Submit
                        </button>
                    </>)
                    }
                    {(!disable && !viewMode) && (
                        <button
                            type="submit"
                            className="btn btn-secondary mine"
                            style={{ "width": "30%" }}
                        >
                            Review
                        </button>
                    )
                    }
                    {(disable && viewMode) && (
                        <>
                            <div
                                className="btn btn-secondary"
                                onClick={handleBack} style={{ "width": "20%", "margin-right": "5%" }} >
                                Back
                            </div>
                            <div
                                className="btn btn-secondary"
                                onClick={printyo} style={{ "width": "20%", "margin-right": "5%" }}>
                                Print
                            </div>
                        </>
                    )}
                    <br />
                    <br />
                </form>
                <br />
            </center>
        </div>
    </>)

}
